import React from "react";

import { NoticeFilters, recordDetailsUrl } from "components/notices/utils";
import { NoticeSeenBy } from "components/record_details/SeenBy";
import Tooltip from "components/ui/tooltip/Tooltip";
import { EllipsisTooltipTextLink } from "lib/core_components/EllipsisTooltip";
import { useLogEntityView } from "lib/hooks/api/userActivity/useLogEntityView";
import { useRestricedViewNotice } from "lib/hooks/useRestrictedRowClick";
import UIcon from "lib/icons/untitled_ui/UIcon";
import { ProHelperDataTypes } from "lib/providers/ProHelper";
import { useTracking } from "lib/tracking";
import { LoggedEntityType } from "lib/types/graphQLEnums";
import CommentIcon from "../../lib/core_components/CommentIcon";
import { NoticesDto } from "../../lib/hooks/api/notices/useNotices";
import { joinToEnglishList } from "../../lib/utils";
import RedactData from "../ui/redact_data/RedactData";
import BuyersContainer from "./BuyersContainer";

import css from "./TitleCell.module.scss";

export function NewTitleCell({
  notice,
  requiredDataType,
  filters,
}: {
  notice: NoticesDto;
  requiredDataType: ProHelperDataTypes | undefined;
  filters: NoticeFilters;
}) {
  const { trackingData } = useTracking();
  const { viewRecord } = useRestricedViewNotice("Title click", requiredDataType, trackingData);
  const { viewRecord: showPaywallModal } = useRestricedViewNotice("Row-click", "AWARDS");

  const logEntityView = useLogEntityView();
  const noticeName = notice.name || "--";

  return (
    <div className={css.titleContainer}>
      <div className={css.titleCell}>
        <EllipsisTooltipTextLink
          fullText={noticeName}
          linkProps={{
            to: recordDetailsUrl(notice.guid, filters),
            targetType: "new-tab",
            onClick: (e) => {
              e.stopPropagation();
              e.preventDefault();
              if (notice.redacted) {
                showPaywallModal(notice.guid);
              } else {
                viewRecord(notice.guid);
              }
            },
            className: css.titleText,
          }}
          linkText={noticeName}
          tooltipProps={{ contentMaxWidth: 350 }}
        />
        <RedactData isRedacted={notice.redacted} bullets={16}>
          <BuyersContainer
            handleClick={() => logEntityView(LoggedEntityType.Notice, notice.guid)}
            recordName={noticeName}
            buyers={notice.buyers.map((b) => ({ id: b.id, name: b.name }))}
            showAsLinks={false}
          />
        </RedactData>
      </div>
      <div className={css.recordStatus}>
        {notice.lists.length > 0 && (
          <Tooltip content={`Saved to ${joinToEnglishList(notice.lists.map((l) => l.name))}`}>
            <div>
              <UIcon icon="bookmark" size={14} />
            </div>
          </Tooltip>
        )}
        <CommentIcon comments={notice.comments ?? []} />
        <NoticeSeenBy seenByUsers={notice.seenByUsers} />
      </div>
    </div>
  );
}
